import { GET, POST } from './index'

export const listLogFiles = () =>
  GET({
    url: 'admin/scripts/list-log-files'
  })

export const calculateTimeIntervals = ({ clientId, files = [] }) =>
  POST({
    url: 'admin/scripts/time-intervals-by-client',
    data: { clientId, files }
  })
